module.exports = __webpack_public_path__ + "static/hiringBubble-cdc36c5ec152e682e459af73af16625d.svg";